import axios from "axios";
import qs from "qs";
import { CONTENT_TYPE } from "@/apis/constant";
import {pageConfig} from "@/common/service/page-config";

export const generateOnSessionSignature = (params = {}) => axios.post("/opc/onsession/signature/generate", qs.stringify(params), {
  headers: {
    'Content-Type': CONTENT_TYPE.URL_ENCODED,
  },
});

export const generateEWalletSignature = (params = {}) => axios.post("/opc/onsession/signature/generate_ewallet", qs.stringify(params), {
  headers: {
    'Content-Type': CONTENT_TYPE.URL_ENCODED,
  },
});

export const checkSecondToken = (params = {}) => axios.post("/billing/adyen_second_token/check", qs.stringify(params), {
  headers: {
    'Content-Type': CONTENT_TYPE.URL_ENCODED,
  },
});

export const generateCvvReAuthSignature = () => axios.get(`/billing/zuora/signature/generate_cc_reauth?_=${Date.now()}`);

export const generateZuoraSignature = () => axios.get(`/billing/zuora/signature/generate?_=${Date.now()}`);

export const getCountryJson = () => axios.get('/buy/getCountryJson');

export const paypalPlan = (params) => axios.post("/paypal_plan_opc", qs.stringify(params), {
  headers: {
    'Content-Type': CONTENT_TYPE.URL_ENCODED,
  },
});

export const getPaymentBillingInfo = () => axios.get('/payment/info', {params: {pageType: pageConfig.type}});

export const getPaymentGatewayInfo = () => axios.get('/payment/gateway/info');

export const updatePayMethod = (params) => axios.post('/payment/update', params);

export const checkRpsStatus = (params) => axios.post('/buy/e2open_check', qs.stringify(params), {
  headers: {
    'Content-Type': CONTENT_TYPE.URL_ENCODED,
  },
});

export const updateCvvFlag = (params) => axios.post('/billing/fraud/cvv', qs.stringify(params), {
  headers: {
    'Content-Type': CONTENT_TYPE.URL_ENCODED,
  },
});

export const getApmPaymentMethods = ({
  soldToCountry,
  billToCountry,
  currencyCode,
  email,
  accountNumber = null,
  planNames,
  orderData,
  cancelToken
}) =>
  axios.post('/apm/payment-methods', orderData, {
    params: {
      soldToCountry,
      billToCountry,
      currencyCode,
      email,
      accountNumber,
      planNames,
      showDefaultTiles: 'true'
    },
    timeout: 15000,
    paramsSerializer: (params) => {
      return qs.stringify(params, {arrayFormat: 'repeat'})
   },
   cancelToken
  });


export const apmFundingInstructions = ({
  email,
  currencyCode
}) =>
  axios.get("/apm/funding_instructions", {
    params: {
      email,
      currencyCode
    }
  });

// get apm (Stripe) payment information
export const apmPaymentInfo = ({
  email,
  paymentIntentId
}) =>
axios.post('/apm/payment_info', null, {
  params: {
    email,
    paymentIntentId
  }
});

// apm biling event status
export const apmEventStatus = ({
  payload,
  email
}) =>  axios.post(`/apm/billing/event/status?email=${encodeURIComponent(email)}`, payload, {
  headers: {
    'Content-Type': CONTENT_TYPE.JSON
  }
});

// set apm info to be sent to APM pages
export const apmSetInfo = ({
  payload
}) => axios.post('/apm/set/info', payload);

// sign user into the pay now flow
export const payNowSignin = (payload) =>
  axios.post('/paynow/lcr/signin', payload, {
    headers: {
      'Content-Type': CONTENT_TYPE.URL_ENCODED,
    },
  })

// APM update payment setup for billing management flow
export const updatePaymentSetup = ({ payload, email }) =>
  axios.post(`/apm/payment-method/update?email=${encodeURIComponent(email)}`, payload)


export const updateSuccessPageCtaLinks = (payload) =>
  axios.post(`/opc/buy/success/cta_links`, payload)
